"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedTypeExplainBanner = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactA = _interopRequireDefault(require("@adsk/alloy-react-a"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _useTranslations = require("../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FixedTypeExplainBanner = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "100%",
      height: 50,
      paddingLeft: "15px",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: 18,
      paddingRight: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.AlertInformationIcon, {
    size: 16
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, T.translate("referencePickerPlugin.fixedTypeBannerContent"), "\xA0", /*#__PURE__*/_react.default.createElement(_alloyReactA.default, {
    href: T.translate("referencePickerPlugin.fixedTypeBannerHelpUrl"),
    target: "_blank"
  }, T.translate("referencePickerPlugin.fixedTypeBannerHelpText")))));
};
exports.FixedTypeExplainBanner = FixedTypeExplainBanner;
//# sourceMappingURL=FixedTypeExplainBanner.js.map